export class VehicleModel {
  /**
   *@var error to store error status
   **/
  public error: any;
  /**
   *@var vin to store vin
   **/
  private vin: string;
  constructor(vin: string) {
    this.vin = vin;
  }
  /**
   * placeholder returns the placeholder
   **/
  get placeholders(): string {
    return 'findVehicle.form.vin';
  }
  /**
   * title returns if the title of the search bar
   **/
  get title(): string {
    return 'findVehicle.labels.title';
  }
  /**
   * apiCall returns if the model needs an api call  or not
   **/
  get apiCall(): boolean {
    return true;
  }

  /**
   * getApitype returns api type
   **/
  public get getApitype(): object {
    return {
      type: 'cvs_details', params: { vin: this.vin }
    };
  }
  /**
   * getRouteParams Returns the routing parameters for redirection
   **/
  get getRouteParams(): object {
    return {};
  }
}
